import React from 'react';

interface AccountPropertyProps {
    property: string;
    value?: React.ReactNode;
}

export const AccountProperty = ({ property, value }: AccountPropertyProps) => {
    return value && (typeof value === 'string' ? value.length > 1 : true) ? (
        <div className="field-group">
            <div className="field-key">{property}</div>
            {value}
        </div>
    ) : (
        <div className="field-group">
            <div className="field-key">{property}</div>
            <div className="field-value">{value ? value : 'N/A'}</div>
        </div>
    );
};
